import { render, staticRenderFns } from "./EditOrderItemPriceDialog.vue?vue&type=template&id=32460a84&scoped=true"
import script from "./EditOrderItemPriceDialog.vue?vue&type=script&lang=js"
export * from "./EditOrderItemPriceDialog.vue?vue&type=script&lang=js"
import style0 from "./EditOrderItemPriceDialog.vue?vue&type=style&index=0&id=32460a84&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "32460a84",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/app/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('32460a84')) {
      api.createRecord('32460a84', component.options)
    } else {
      api.reload('32460a84', component.options)
    }
    module.hot.accept("./EditOrderItemPriceDialog.vue?vue&type=template&id=32460a84&scoped=true", function () {
      api.rerender('32460a84', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/order/AdminSummarySubs/EditOrderItemPriceDialog.vue"
export default component.exports